import React from "react";
import ReactDOM from "react-dom";
import { createGenerateClassName } from "@mui/styles";

import EntryWrapper from "./entry-wrapper";
import Articles from "./../components/articles";

const generateClassName = createGenerateClassName({
  productionPrefix: "art",
});

const EntryArticles = document.getElementById("sa_content_filtering_entry-articles");
ReactDOM.render(
  <EntryWrapper generateClassName={generateClassName}>
    <Articles />
  </EntryWrapper>,
  EntryArticles
);

export default EntryArticles;
